import { motion } from "framer-motion";
import { useI18n } from "../i18n/LanguageContext";

export const CognitiveLoader = ({ query }) => {
  const { t } = useI18n();
  const stages = t("loader.stages");
  return (
    <div
      data-testid="cognitive-loading"
      className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6"
    >
      <div className="relative w-28 h-28 mb-10">
        <div className="absolute inset-0 rounded-full border border-[#1E6FFF]/30 animate-spin-slow" />
        <div className="absolute inset-3 rounded-full border border-[#4BE3FF]/40 animate-[spin-slow_18s_linear_infinite_reverse]" />
        <motion.div
          className="absolute inset-0 flex items-center justify-center"
          animate={{ scale: [1, 1.15, 1] }}
          transition={{ duration: 1.6, repeat: Infinity }}
        >
          <span className="w-4 h-4 rounded-full bg-[#4BE3FF] cyan-glow-strong" />
        </motion.div>
      </div>

      <p className="font-mono text-[12px] uppercase tracking-[0.3em] text-[#4BE3FF] mb-3">
        {t("loader.reasoning")}
      </p>
      <p className="font-display text-xl md:text-2xl text-white max-w-xl mb-10">
        {query}
      </p>

      <div className="flex flex-col gap-2.5 w-full max-w-xs">
        {stages.map((s, i) => (
          <motion.div
            key={s}
            initial={{ opacity: 0.25 }}
            animate={{ opacity: [0.25, 1, 0.25] }}
            transition={{ duration: 1.6, repeat: Infinity, delay: i * 0.4 }}
            className="flex items-center gap-3 font-mono text-[13px] text-[#A7B4C2]"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#4BE3FF]" />
            {s}
          </motion.div>
        ))}
      </div>
    </div>
  );
};
